import {useMutation, useQuery} from "react-query";
import {getAxios, postFormAxios} from "../../axios/generic-api-calls";
import {ProfileModel, ProfileUpdateAvatarModel, ProfileUpdateBannerModel, ProfileUpdateModel} from "./profileTypes";
import {queryClient} from "../../App";
import {AxiosError} from "axios";

export type ValidationError = {
    message: string;
    errors: { [key: string]: string[] };
};


export function useFetchProfileByUsername(username:string, key:string = 'profile') {
    return useQuery<ProfileModel>(key, () => getAxios(`/profile/${username}`));
}

export function useFetchUserProfile(key:string = 'profile.currentUser') {
    return useQuery<ProfileModel>(key, () => getAxios(`/profile`));
}

export function useUpdateUserProfile() {
    return useMutation<ProfileUpdateModel, AxiosError, ProfileUpdateModel>((updatedProfile) => postFormAxios(`/profile`, updatedProfile),
        {
            onSuccess: async () => {
                await queryClient.invalidateQueries('profile.currentUser');
            },
        },
    );
}

export function useUpdateUserAvatar() {
    return useMutation<ProfileUpdateAvatarModel, AxiosError, ProfileUpdateAvatarModel>((updatedAvatar) => postFormAxios(`/profile/avatar`, updatedAvatar),
        {
            onSuccess: async () => {
                await queryClient.invalidateQueries('profile.currentUser');
            }
        }
    );
}

export function useUpdateUserBanner() {
    return useMutation<ProfileUpdateBannerModel, AxiosError, ProfileUpdateBannerModel>((updatedBanner) => postFormAxios(`/profile/banner`, updatedBanner),
        {
            onSuccess: async () => {
                await queryClient.invalidateQueries('profile.currentUser');
            }
        }
    );
}
